var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPopularMusic = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Music-Genre-Star--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Music Genre Star Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.25 17.37A3.23 3.23 0 0 1 16 15.3a0.24 0.24 0 0 0 0 -0.24l-0.83 -2.44a0.25 0.25 0 0 1 0.08 -0.27l4.47 -3.84A1.43 1.43 0 0 0 18.83 6h-5.27a0.24 0.24 0 0 1 -0.23 -0.16L11.46 0.93A1.41 1.41 0 0 0 10.13 0a1.44 1.44 0 0 0 -1.34 0.92L6.93 5.84a0.25 0.25 0 0 1 -0.24 0.16H1.43A1.43 1.43 0 0 0 0.5 8.51L5 12.35a0.27 0.27 0 0 1 0.07 0.27l-1.88 5.5a1.43 1.43 0 0 0 2.19 1.61L10 16.47a0.26 0.26 0 0 1 0.29 0l4.28 3a0.24 0.24 0 0 0 0.27 0l0.29 -0.15a0.26 0.26 0 0 0 0.14 -0.23Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.63 14.24 -3.57 1.14a2 2 0 0 0 -1.56 1.95v3a0.26 0.26 0 0 1 -0.19 0.25 1.75 1.75 0 1 0 2.19 1.69v-4.76a0.23 0.23 0 0 1 0.18 -0.23l3 -1a0.25 0.25 0 0 1 0.33 0.24v1.75a0.26 0.26 0 0 1 -0.19 0.25A1.75 1.75 0 1 0 24 20.25V16.2a2 2 0 0 0 -2.37 -1.96Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPopularMusic);
export default ForwardRef;